import { render, staticRenderFns } from "./WorkflowFormSubmissionActivityDialog.vue?vue&type=template&id=d27d7b60&"
import script from "./WorkflowFormSubmissionActivityDialog.vue?vue&type=script&lang=ts&"
export * from "./WorkflowFormSubmissionActivityDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports